import React from 'react'

//Final Form
import { Form, FormSpy } from 'react-final-form'
import arrayMutators from 'final-form-arrays'

//Material-UI
import Grid from '@material-ui/core/Grid'

import Dialog from '../../../../../../control/dialog/dialog'
import TextField from '../../../../../../control/textfield/textfield'
import UploadDoc from '../../../../shareUI/uploadDoc/uploadDoc'
import PageAction from '../../pageAction'
import MyAccordion from '../../../../../../control/accordion/accordion'

import useSnackbarAction from '../../../../../../stores/snackbar/snackbarAction'
import useTranslate from '../../../../../../i18n/useTranslate'
import useSubmittedWithdraw from './useSubmittedWithdraw'
import useCheckPermission from '../../../../../../utilities/checkPermission'
import UploadAdditionalDoc from '../../../../shareUI/uploadAdditionalDoc/UploadAdditionalDoc'

type SubmittedWithdrawViewProps = ReturnType<typeof useSubmittedWithdraw> & SubmittedWithdrawProps
const SubmittedWithdrawView: React.FC<SubmittedWithdrawViewProps> = (props) => {
    const {
        initialVal,
        initialUploadFile,
        uploadDocumentTopic,
        isViewMode,
        isHideUploadSection,
        configDialog,
        onClickCancel,
        onSubmit,
        onRefDialog,
        onDirtyChange,
        projectData,
    } = props
    const translate = useTranslate()
    const snackbarAction = useSnackbarAction()

    const checkPermission = useCheckPermission()
    const canUpdateDocument = checkPermission.checkCanUpdateDocument(projectData, checkPermission.isUserAdmin())

    return (
        <Form
            onSubmit={onSubmit}
            mutators={{
                ...arrayMutators,
            }}
            initialValues={initialVal}
            keepDirtyOnReinitialize={true}
        >
            {({ handleSubmit, dirty, invalid, errors }) => {
                return (
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <MyAccordion title={translate.get('LABEL.WITHDRAW_REASON')}>
                                <TextField
                                    name="withdrawCause"
                                    required
                                    materialInputProps={{
                                        label: translate.get('LABEL.REASON'),
                                        disabled: isViewMode,
                                        multiline: true,
                                        rows: 5,
                                    }}
                                    maxLength={1000}
                                    resetButtom
                                />
                            </MyAccordion>
                        </Grid>
                        {!isHideUploadSection && (
                            <>
                                <Grid item xs={12}>
                                    <UploadDoc
                                        initialData={initialUploadFile}
                                        documentTitleList={uploadDocumentTopic}
                                        isViewMode={isViewMode && !canUpdateDocument}
                                        latestDocument={undefined}
                                        isUseUploadfileEdit={false}
                                        isRequire={false}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <UploadAdditionalDoc isViewMode={isViewMode && !canUpdateDocument} />
                                </Grid>
                            </>
                        )}

                        {!isViewMode || canUpdateDocument ? (
                            <Grid item xs={12}>
                                <PageAction
                                    onClickClose={() => {
                                        onClickCancel(dirty)
                                    }}
                                    onClickSave={() => {
                                        handleSubmit()
                                        invalid &&
                                            errors &&
                                            snackbarAction.openSnackbar({
                                                message: translate.get('MESSAGE.M012'),
                                                type: 'error',
                                            })
                                    }}
                                />
                            </Grid>
                        ) : null}

                        <Dialog onRef={onRefDialog} {...configDialog} />
                        <FormSpy subscription={{ dirty: true }} onChange={onDirtyChange} />
                    </Grid>
                )
            }}
        </Form>
    )
}

type SubmittedWithdrawProps = {}
const SubmittedWithdraw: React.FC<SubmittedWithdrawProps> = (props) => {
    const model = useSubmittedWithdraw()
    return <SubmittedWithdrawView {...model} {...props} />
}

export default SubmittedWithdraw
